'use client';

import {
  ArticleCard,
  AuthorByline,
  CardDate,
  Excerpt,
  Title,
} from '@/app_components/ArticleSections/ArticleCards/ArticleCard';
import { useContentCardTrackingData } from '@/app_lib/services/contentCardTracking';
import { getExtendedArticle } from '@/app_lib/services/contentCardTracking/utils';
import type { ArticlePreview } from '@/app_lib/types/ArticlePreview';
import type { ModuleType } from '@/app_lib/types/ContentCardTracking';

export const ArticleCardVertical = ({
  article,
  className,
  index = 1,
  moduleType = 'vertical',
}: {
  article: ArticlePreview;
  className?: string;
  index?: number;
  moduleType?: ModuleType;
}) => {
  const generateContentCardTrackingData = useContentCardTrackingData();

  return (
    <ArticleCard
      className={className}
      variant='vertical'
    >
      <div className='flex flex-col gap-sm'>
        <Title
          contentCardTrackingData={generateContentCardTrackingData({
            article: getExtendedArticle(article),
            cardPosition: index,
            clickTarget: 'headline',
            moduleType,
          })}
          title={article.title}
          url={article.url}
          variant='vertical'
        />
        <Excerpt
          excerpt={article.excerpt}
          variant='vertical'
        />
      </div>
      <div className='flex flex-col'>
        <AuthorByline
          authors={article.authors}
          contentCardTrackingData={generateContentCardTrackingData({
            article: getExtendedArticle(article),
            cardPosition: index,
            clickTarget: 'author',
            moduleType,
          })}
          variant='vertical'
        />
        <CardDate
          dateGmt={article.dateGmt}
          variant='vertical'
        />
      </div>
    </ArticleCard>
  );
};
